import Vue from 'vue'
import ky from './utils/ky'
import Events, { confirm } from './utils/events'
import Pusher from './utils/pusher'

import App from './Main.vue'
import router from './router'
import store from './store'

import VCalendar from 'v-calendar'
import vSelect from 'vue-select'
import VueMasonry from 'vue-masonry-css'
import 'vue-select/dist/vue-select.css'
import { Icon } from '@iconify/vue2'

import { VueInputMask } from './plugins'

import customElements from '@/utils/customElements'
// import 'windi.css'
// import 'virtual:windi-base.css'
import 'virtual:windi-components.css'
import 'virtual:windi-utilities.css'

Vue.use(customElements)
Vue.use(VueInputMask)
Vue.use(VCalendar, { componentPrefix: 'vue' })
Vue.use(VueMasonry)
Vue.component('Icon', Icon)
Vue.component('vSelect', vSelect)

Vue.config.productionTip = false
Vue.prototype.$http = ky
Vue.prototype.$events = Events
Vue.prototype.$pusher = Pusher

Vue.prototype.$now = () => store.getters.now
Vue.prototype.$isGod = () => store.getters.hasRole('god')
Vue.prototype.$hasRole = role => store.getters.hasRole(role)
Vue.prototype.$hasRoles = (roles, all) => store.getters.hasRoles(roles, all)
Vue.prototype.$notify = e => {
  Events.$emit('notification', e)
}
Vue.prototype.$imageViewer = e => {
  Events.$emit('imageViewer', e)
}
Vue.prototype.$confirm = confirm

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
